import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const convective: Palette[] = [
    {
        id: GDFPalletCode.lamp_prb,
        name: 'LAMP Probability',
        type: 'gradientBar',
        minValue: 0,
        maxValue: 255,
        maxDisplayValue: 100,
        units: '%',
        tooltipSingleValue: true,
        stops: [
            { value: 0, color: '#f2eedd' },
            { value: 1, color: '#f2eedd', hideLabel: true },
            { value: 10, color: '#a9daa2' },
            { value: 20, color: '#30b323' },
            { value: 30, color: '#c4c400' },
            { value: 40, color: '#ffe500' },
            { value: 50, color: '#ff8800' },
            { value: 60, color: '#ff506e' },
            { value: 70, color: '#e55ecc' },
            { value: 80, color: '#800080' },
            { value: 90, color: '#6e09d6' },
            { value: 100, color: '#b6a4ff' }
        ],
        getValue: (value) => value
    },
    {
        id: GDFPalletCode.lamp_cat,
        name: 'LAMP Category',
        type: 'categorical',
        entries: [
            { color: '#00000000', label: 'None' },
            { color: '#fd9526', label: 'Low' },
            { color: '#fc351d', label: 'Medium' },
            { color: '#cb0814', label: 'High' }
        ],
        tooltipSingleValue: true
    },
    {
        id: GDFPalletCode.cb_tops,
        name: 'Cumulonimbus Tops',
        type: 'discreteBar',
        colors: ['#000', '#7a7a7a', '#9b9b9b', '#bcbcbc', '#dddddd', '#ffffff'],
        values: [30, 35, 40, 45, 50],
        units: 'ft',
        suffix: 'k'
    },
    {
        id: GDFPalletCode.cb_extents,
        name: 'Cumulonimbus Horizontal Extents',
        type: 'discreteBar',
        colors: ['#000', '#858585', '#aeaeae', '#d7d7d7', '#ffffff'],
        values: [30, 50, 70, 90],
        units: '%'
    },
    {
        id: GDFPalletCode.sehzd_tstorm,
        name: 'Enhanced thunderstorms',
        type: 'discreteBar',
        colors: ['#000', '#ffff00', '#ffe100', '#ffa500', '#ff8c00', '#ff7d00', '#ff6400', '#ff4b00', '#ff3200', '#ff1900', '#ff0000'],
        values: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
        units: 'm/s'
    },
    {
        id: GDFPalletCode.probsevere_light,
        name: 'Severe weather probability',
        type: 'categorical',
        entries: [
            { label: '>= 90%', color: 'rgb(255, 0, 255)' },
            { label: '>= 70%', color: 'rgb(255, 0, 0)' },
            { label: '>= 50%', color: 'rgb(255, 255, 0)' },
            { label: '>= 30%', color: 'rgb(0, 0, 255)' },
            { label: '>= 0%', color: '#000' }
        ]
    },
    {
        id: GDFPalletCode.probsevere_dark,
        name: 'Severe weather probability',
        type: 'categorical',
        entries: [
            { label: '>= 90%', color: 'rgb(255, 0, 255)' },
            { label: '>= 70%', color: 'rgb(255, 0, 0)' },
            { label: '>= 50%', color: 'rgb(255, 255, 0)' },
            { label: '>= 30%', color: 'rgb(0, 0, 255)' },
            { label: '>= 0%', color: '#fff' }
        ]
    }
];
